import { IconProps } from "components/SvgImage/IconProps";
import { CFC } from "types/commonExtend/CFC";

export const createIcon = (name: string, Component: CFC<IconProps>): CFC<IconProps> => {
  // @ts-ignore
  Component.displayName = name;
  return Component;
};
